/* global femcare */

femcare.navigation.navigationMain = {
    $menuModal: $('#menuModal'),
    $searchModal: $('#searchModal'),
    $cartModal: $('#cartModal'),
    $stashModal: $('#stashModal'),
    $submenuToggles: $('.navigation-bar__topics > li > a[aria-haspopup]'),

    init: function () {
        if ($('.navigation').length) {
            this.initDesktopNavigation();
            this.initLanguagePopout();
            this.initMobileNavigation();
            this.sampleLabelText();
        }
    },

    initDesktopNavigation: function () {
        this.initStickyNavigation();

        this.$submenuToggles.on('click', function (e) {
            e.preventDefault();  
            e.stopPropagation();

        });

        this.$submenuToggles.each(function (index, toggle) {
            var $toggle = $(toggle);
            $toggle.parent().hover(
                $.proxy(function () {
                    this.launchNav($toggle);
                }, this),
                $.proxy(function () {
                    this.terminateNav();
                }, this));
        }.bind(this));
    },

    initLanguagePopout: function () {
        var $popout = $('.navigation-bar__language-popout');

        if ($popout.length) {

            $popout.on('click', function (e) {
                e.stopPropagation();
            });

            function closeLanguageSubmenu() {
                $popout.hide();
                $('html').unbind('click', closeLanguageSubmenu);
            }

            $('.navigation-bar__language-toggle').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if ($popout.is(':visible')) {
                    $popout.hide();
                    $('html').unbind('click', closeLanguageSubmenu);
                } else {
                    $popout.show();
                    $('html').on('click', closeLanguageSubmenu);
                }
            });
        }
    },

    /**
     * Open the navigation and bind event handlers.
     * @param {object} $toggle target submenu toggle
     */
    launchNav: function ($toggle) {
        var that = this;

        $('.navigation').addClass('open');

        this.openSubmenu($toggle);

        // Terminate nav if click outside navigation.
        $('html').on('click', function (e) {
            var $target = $(e.target);
            if (
                !$target.hasClass('navigation') &&
                $target.parents('.navigation').length === 0
            ) {
                that.terminateNav();
            }
        });

        // Terminate nav if press escape.
        var escapeKey = 27;
        $(document).on('keyup', function (e) {
            if (e.keyCode === escapeKey) {
                that.terminateNav();
            }
        });

        // Terminate nav on blur outside opened item.
        this.$submenuToggles.parent().each(function (index, submenuParent) {
            var timeout = 10;
            $(submenuParent)
                .find('a')
                .on('blur', function () {
                    setTimeout(function () {
                        if (!$.contains(submenuParent, document.activeElement)) {
                            that.terminateNav();
                        }
                    }, timeout);
                });
        });
    },

    /**
     * Close the navigation and unbind event handlers.
     */
    terminateNav: function () {
        $('.navigation').removeClass('open');

        this.closeSubmenu();

        $(document).off('keyup');
        $('html').off('click');
        this.$submenuToggles
            .parent()
            .find('a')
            .off('blur');
    },

    /**
    * Open submenu.
    * @param {object} $toggle target submenu toggle
    */
    openSubmenu: function ($toggle) {
        $toggle.addClass('open');
        $toggle.attr('aria-expanded', true);

        var submenu = $toggle.parent().find('.navigation-bar__submenu');
        submenu
            .stop()
            .show()
            .addClass('open');
    },

    /**
     * Close opened submenu.
     */
    closeSubmenu: function () {
        this.$submenuToggles
            .removeClass('open')
            .attr('aria-expanded', false);
        $('.navigation-bar .navigation-bar__submenu')
            .hide()
            .removeClass('open');
    },

    initStickyNavigation: function () {
        $(window).on('resize', this.applyStickyBehavior);
        this.applyStickyBehavior();
    },

    applyStickyBehavior: function () {
        var $navigation = $('.navigation');

        if (femcare.shared.util.isRichNavbarActive()) {
            if ($(window).scrollTop() > $navigation.outerHeight()) {
                $navigation.addClass('affix');
            }

            $navigation.affix({
                offset: {
                    top: $navigation.outerHeight()
                }
            });
        }
    },

    initMobileNavigation: function () {
        this.initMobileAccordion();
        this.initOpenMenuHandlers();
        this.initCloseMenuHandlers();

        $(window).on('resize', $.proxy(this.hideNavigationModal, this));
        this.hideNavigationModal();

        this.initMobileNavScrollReveal();
        this.initFocusSearch();
    },

    hideNavigationModal: function () {
        if (
            this.$menuModal.is(':visible') &&
            femcare.shared.util.isRichNavbarActive()
        ) {
            this.$menuModal.modal('hide');
        }

    },

    /**
     * Hide/show mobile menu depending if scrolling upwards.
     */
    initMobileNavScrollReveal: function () {
        var $navigation = $('.navigation'),
            $stickyAnchor = $('.sticky-anchor'),
            globalNavHeight = $navigation.height(),
            $window = $(window),
            delta = 5,
            lastScrollTop = 0,
            hasScrolled = function () {
                var scrollTop = $window.scrollTop();
                // Make sure they scroll more than delta
                if (Math.abs(lastScrollTop - scrollTop) <= delta) {
                    return;
                }

                if (scrollTop > lastScrollTop && scrollTop > globalNavHeight) {
                    // Scroll Down
                    $navigation.addClass('navigation--hidden');
                    $stickyAnchor.removeClass('offset');
                } else if (scrollTop + $(window).height() < $(document).height()) {
                    // Scroll Up
                    $navigation.removeClass('navigation--hidden');
                    $stickyAnchor.addClass('offset');
                }
                lastScrollTop = scrollTop;
            },
            onScroll = $.proxy(function () {
                if (femcare.shared.util.isRichNavbarActive()) {
                    $navigation.removeClass('navigation--hidden');
                } else {
                    hasScrolled();
                }
            }, this);

        onScroll();
        $window.on('scroll', onScroll);
    },

    initMobileAccordion: function () {
        var $accordion = $('.mobile-navigation__topics');
        var toggleIconSelector = '.mobile-navigation__submenu-toggle';
        var expandedClass = 'mobile-navigation__submenu-toggle--expanded';

        $accordion.accordion({
            header: '.mobile-navigation__accordion-header',
            beforeActivate: function (event, ui) {
                $(ui.oldHeader)
                    .find(toggleIconSelector)
                    .toggleClass(expandedClass);
                $(ui.newHeader)
                    .find(toggleIconSelector)
                    .toggleClass(expandedClass);
            },
            collapsible: true,
            active: false,
            heightStyle: 'content'
        });
    },

    initFocusSearch: function () {
        var $navigation = $('.navigation');

        this.$searchModal.on('show.bs.modal', function () {
            if (this.$menuModal.is(':visible')) {
                this.$menuModal.modal('hide');
            }

            if (this.$cartModal.is(':visible')) {
                this.$cartModal.modal('hide');
            }

            if (this.$stashModal.is(':visible')) {
                this.$stashModal.modal('hide');
            }

            $navigation.addClass('navigation--hidden');
        }.bind(this));

        this.$searchModal.on('shown.bs.modal', function () {
            $(this)
                .find('form input')
                .trigger('focus');
        });

        this.$searchModal.on('hidden.bs.modal', function () {
            $navigation.removeClass('navigation--hidden');
        });
    },

    initOpenMenuHandlers: function () {
        this.$menuModal.on('show.bs.modal', function () {
            if (this.$cartModal.is(':visible')) {
                this.$cartModal.modal('hide');
            }
            if (this.$stashModal.is(':visible')) {
                this.$stashModal.modal('hide');
            }
        }.bind(this));

        this.$menuModal.on('shown.bs.modal', function () {
            $('body').css('position', 'fixed');
            $('.navigation-bar').addClass('navigation-bar--overlayed');
            $('.navigation-bar__icon--toggle i')
                .removeClass('icon-menu')
                .addClass('icon-close');
        });
    },

    initCloseMenuHandlers: function () {
        this.$menuModal.on('hide.bs.modal', function () {
            $('body').css('position', 'static');
            $('.navigation-bar').removeClass('navigation-bar--overlayed');
            $('.navigation-bar__icon--toggle i')
                .removeClass('icon-close')
                .addClass('icon-menu');
        });
    },

    sampleLabelText: function () {
        var $firstHalfIcons = $('.navigation-bar__half--first .navigation-bar__icons');
        var $sampleLabel = $firstHalfIcons.find('.navigation-bar__icon--primary span');
        var hasSampleLabel = $sampleLabel.length;
        var $menuItemAsSample = $('.navigation .navigation-bar__topic .icon-sample');

        if($menuItemAsSample.length) {
            var $navBarTopic = $menuItemAsSample.parents('.navigation-bar__topic');
            var navBarTopicWidth = $navBarTopic.width();

            if(navBarTopicWidth > 98 || navBarTopicWidth === 0){
                $navBarTopic.addClass('navigation-bar__topic--large-text');
            }
        }

        if(hasSampleLabel) {
            var labelHeight = $sampleLabel.width();

            if(labelHeight > 108 || labelHeight === 0){
                $firstHalfIcons.addClass('navigation-bar__icons--large-text');
            }
        }
    }
};
